var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReplaceWith(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.12,
    height: 22.803,
    viewBox: "0 0 19.12 22.803",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.25 0.248)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M403.95,104.776a9.191,9.191,0,0,1,4.7-7.86,8.918,8.918,0,0,1,.838-.435c.2-.091.424-.146.534.126.1.249-.041.379-.263.482a8.541,8.541,0,0,0-4.655,5.091,8.378,8.378,0,0,0-.1,5.274,8.591,8.591,0,0,0,6.027,5.864c.219.059.383.156.345.4-.04.266-.245.294-.459.244a8.458,8.458,0,0,1-2.542-1.076,9.188,9.188,0,0,1-3.506-3.911A10.066,10.066,0,0,1,403.95,104.776Z",
    transform: "translate(-403.95 -93.841)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.016,101.859a9.263,9.263,0,0,1-4.407,7.812,9.7,9.7,0,0,1-1.232.631.3.3,0,0,1-.439-.173c-.072-.208.036-.341.2-.442a.609.609,0,0,1,.057-.027,8.449,8.449,0,0,0,4.662-5.078,8.349,8.349,0,0,0,.1-5.275,8.5,8.5,0,0,0-3.327-4.617,9.092,9.092,0,0,0-2.7-1.263.549.549,0,0,1-.314-.221.346.346,0,0,1,.055-.333.591.591,0,0,1,.433-.074,11.6,11.6,0,0,1,1.45.524,9.189,9.189,0,0,1,4.947,5.449A9.872,9.872,0,0,1,500.016,101.859Z",
    transform: "translate(-481.396 -90.676)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.663,217.193c-.088-.079-.265-.17-.257-.243a.616.616,0,0,1,.207-.43c.368-.219.769-.386,1.156-.573.5-.241,1-.48,1.5-.726.209-.1.242-.22.055-.4-.653-.64-1.293-1.293-1.936-1.943-.3-.3-.362-.527-.18-.665.279-.211.466,0,.646.179.794.8,1.589,1.592,2.377,2.394.36.367.3.573-.168.8-1,.473-1.983.96-2.975,1.439C450.966,217.077,450.837,217.122,450.663,217.193Z",
    transform: "translate(-444.532 -194.927)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.522,78.248l1.457,1.478q.4.4.8.8c.168.17.235.355.047.548s-.369.075-.516-.072q-1.273-1.266-2.537-2.541c-.3-.3-.257-.527.147-.728.741-.37,1.491-.723,2.237-1.084.312-.151.621-.308.936-.451.2-.09.416-.168.541.1.116.248-.029.389-.244.493q-1.262.608-2.519,1.227A3.583,3.583,0,0,0,473.522,78.248Z",
    transform: "translate(-463.9 -76.118)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReplaceWith);
export default __webpack_public_path__ + "static/media/replace-with.d9d2fcc4745fc2c8320a78b34d51a4a4.svg";
export { ForwardRef as ReactComponent };